var MD5 = require('md5.js')

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}



//////////////////
// WEBPACK FOOTER
// ./~/create-hash/md5.js
// module id = 555
// module chunks = 1